import React from 'react';
const stats = [['500+', 'Coaches'], ['1 + 5', 'Box Set & Bonuses'], ['4.9/5', 'Average rating'], ['Worldwide', 'Trusted globally']];
const notes = [['“I planned my entire season in one evening. Every session now has a clear objective.”', 'James M.', 'Lancashire, UK'], ['“The progressions are logical and the players can feel themselves improving.”', 'Coach David', 'Melbourne, Australia'], ['“Everything I need is right there. No more hours searching for drills.”', 'Priya T.', 'Auckland, NZ']];
export function ProofSection() {
  return <section className="bg-[#0A0A0A] px-5 pb-16" data-id="element-180">
      <div className="mx-auto max-w-6xl" data-id="element-181">
        <div className="grid grid-cols-2 border border-[#d4af37]/25 bg-[#16161F] sm:grid-cols-4" data-id="element-182">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-[#d4af37]/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-183">
              <p className="font-display text-4xl font-bold uppercase text-[#d4af37] sm:text-5xl" data-id="element-184">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-185">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-186">
          {notes.map(([quote, name, location]) => <figure key={name} className="flex flex-col border border-[#E5E5EA] bg-white p-6" data-id="element-187">
              <div className="mb-4 text-[#d4af37]" aria-label="5 out of 5 stars" data-id="element-188">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-189">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-[#E5E5EA] pt-4 text-sm font-bold text-[#0A0A0A]" data-id="element-190">
                {name}
                <span className="ml-2 text-xs font-medium text-[#5A5A66]" data-id="element-191">
                  {location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}